

import { commonfunc } from '~/mixin/common'
import { pdMixin } from '@/mixin/pd/pdMixin'
export default {
  mixins: [commonfunc, pdMixin],
  props: {
    isOldChange: {
      type: Object,
      default: () => {
        return {
          val: 0,
          pdNo: ''
        }
      }
    },
    isAlert: {
      type: [Boolean],
      default: false,
    },
    value: {
      type: [String, Number],
      default: 1,
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    type: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    spbkSeCd: { // 장바구니구분코드
      type: String,
      default: ''
    },
    pkgYn: { // 덕용, 패키지 상품 여부
      type: String,
      default: 'N'
    },
    jpQy: { // 중포수량
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      itemInfo: this.item,
      inputValue: this.value,
      selectOpen: false,
      oldVal: this.value,
      orderOldQy: 1,
      cntList: [], // 수량 리스트
    }
  },
  watch: {
    value (val) {
      if (this.type === 'order') {
        this.setInputValue()
      } else if (this.type !== 'order') {
        this.inputValue = val
        this.oldVal = val
      }
    },
    isAlert () {
      if (this.isAlert) {
        if (this.isOldChange.pdNo === this.itemInfo.pdNo) {
          this.$emit('alert-change', false)
          this.oldVal = this.isOldChange.val
        }
      }
    },
    item: {
      handler (item) {
        this.itemInfo = { ...item }
        if (this.type === 'order') {
          this.setInputValue()
        }
        this.changeCntList()
      },
      deep: true
    },
    spbkSeCd (val) {
      if (this.type !== 'order') {
        this.changeCntList()
      }
    },
    pkgYn () {
      if (this.type !== 'order') {
        this.changeCntList()
      }
    }
  },
  mounted () {
    this.changeCntList()
    if (this.type === 'order') {
      this.orderOldQy = this.value
    }
  },
  methods: {
    // input 입력으로 수량 변경했을 때
    changeNumber () {
      if (this.inputValue === '') {
        this.inputValue = 1
      }
      if (this.type === 'order') {
        if (!this.item.massOrPsblYn && this.inputValue > this.item.maxOrPsblQy) {
          let msgStr = '최대 주문 가능 수량은 '
          msgStr += this.pkgYn === 'Y' || this.item.spbkSeCd === '04' ? this.item.maxOrPsblQy + '박스(' + this.numberComma(this.item.maxOrPsblQy * this.jpQy) + '개) 입니다.' : this.item.maxOrPsblQy + '개 입니다.'
          this.$alert(msgStr)

          this.inputValue = this.oldVal
        } else if (this.pkgYn === 'Y' || this.item.spbkSeCd === '04') {
          this.$emit('changeNumber', { item: this.itemInfo, n: parseInt(this.inputValue) * parseInt(this.jpQy), o: parseInt(this.oldVal) * parseInt(this.jpQy) })
        } else {
          this.$emit('changeNumber', { item: this.itemInfo, n: parseInt(this.inputValue), o: parseInt(this.oldVal) })
        }
      } else if (this.type !== 'order') {
        if (this.pkgYn === 'Y' || (this.spbkSeCd === '04' && !this.item.isOnldOpt)) {
          this.$EventBus.$emit('changeNumber', this.itemInfo.pdNo, parseInt(this.inputValue) * parseInt(this.jpQy), (this.pkgYn === 'Y' && parseInt(this.oldVal) === parseInt(this.jpQy)) ? parseInt(this.oldVal) : parseInt(this.oldVal) * parseInt(this.jpQy), this.pkgYn)
        } else {
          if (this.spbkSeCd === '04' && this.item.isOnldOpt && this.inputValue === '0') {
            this.inputValue = this.oldVal
            this.$notify.closeAll()
            const minCnt = this.item.htrkCnvMummQy * this.item.jpQy
            this.openToast(`${this.item.htrkCnvMummQy}박스(${minCnt}개) 부터 구매 가능한 상품입니다.`)
            this.closeQuantity()
            return
          }

          this.$EventBus.$emit('changeNumber', this.itemInfo.pdNo, this.inputValue, this.oldVal)
        }
      }

      this.closeQuantity()
      if (this.type !== 'order' && this.isAlert === false) {
        this.oldVal = this.inputValue
      }
    },
    // 셀렉트박스 열기
    toggleQuantity () {
      this.selectOpen = !this.selectOpen
      if (this.selectOpen) {
        this.$refs.selectInput.focus()
      }
    },
    // select box 닫기
    closeQuantity () {
      this.selectOpen = false
      this.$refs.selectInput.blur()
    },
    preventE (e) {
      if (this.selectOpen) {
        e.preventDefault()
      }
    },
    validQy (val) {
      this.inputValue = this.getDigits(val)
    },
    setFocus (call, num) {
      if (this.inputValue === '') {
        this.inputValue = this.value
      }

      if (call === 'sel' && num) {
        this.inputValue = num
      }
      if (this.inputValue !== this.oldVal) {
        return this.changeNumber()
      }

      this.closeQuantity()
    },
    setInputValue () {
      // 변동감지시 input값, oldVal값을 재 셋팅
      if (this.item.spbkSeCd !== '04' && this.inputValue > this.item.maxOrPsblQy) {
        this.val = this.orderOldQy
        this.inputValue = this.orderOldQy
        this.oldVal = this.orderOldQy
      } else if (this.item.spbkSeCd === '04' && this.inputValue > parseInt(this.item.stck)) {
        this.val = this.orderOldQy
        this.inputValue = this.orderOldQy
        this.oldVal = this.orderOldQy
      } else {
        this.inputValue = this.value
        this.orderOldQy = this.value
        this.oldVal = this.value
      }
    },
    changeCntList () { // 수량 리스트 설정
      let cntArr = []
      if (this.spbkSeCd !== '04') {
        cntArr = Array(this.item.viewType === 'bun' ? this.item.max : this.item.maxOrPsblQy).fill().map((v, i) => i + 1)
        if (this.spbkSeCd !== '04' && this.item.massOrPsblYn) {
          cntArr.push(this.item.htrkCnvMummQy)
        }
      } else {
        for (let i = this.item.htrkCnvMummQy; i <= (this.item.viewType === 'bun' ? this.item.max : this.item.maxOrPsblQy); i++) {
          cntArr.push(i)
        }
      }
      this.cntList = cntArr.sort((a, b) => a - b)
    }
  }
}
